import React from "react";
import { Link } from "react-router-dom";

import Card from "../../shared/components/UIElements/Card";

const ActionIndicator = ({ signal }) => {
  const signalMap = {
    1: { text: "Buy", color: "green" },
    0: { text: "Hold", color: "gray" },
    "-1": { text: "Sell", color: "red" },
  };

  const { text, color } = signalMap[signal] || {
    text: "Unknown",
    color: "black",
  };

  return <span style={{ color, fontWeight: "bold" }}>{text}</span>;
};

const InstrumentItem = (props) => {

  const cardStyle = {
    backgroundColor: parseFloat(props.pnl_per_avg) > 0 ? "rgba(0, 255, 0, 0.5)" : "rgba(255, 0, 0, 0.5)",
    borderWidth: "4px",
    borderStyle: "solid",
    borderColor: Number(props.trade) === 1 ? "black" : "transparent",
    borderRadius: "4px", // Optional: to make the border corners rounded
  };

  return (
    <Link to={`/${props.id}`} style={{ textDecoration: "none" }}>
      <Card className="instrument-item" style={cardStyle}>
        <table>
          <tbody>
            <tr>
              {/* <td>{props.id2 + 1}</td> */}
              <td>{props.date}</td>
              <td>{props.title}</td>
              <td>{props.ticker}</td>
              <td>{props.RSI}</td>
              {/* <td>{props.MACD}</td> */}
              {/* <td>{props.VIX}</td> */}
              <td>
                {props.closingPrice}
                {props.priceCurrency && props.priceCurrency !== "USD" && ` ${props.priceCurrency}`}
              </td>
              <td>
                <ActionIndicator signal={props.signal} />
              </td>
              <td>{props.trade}</td>
              <td>{props.pnl_per_avg}</td>
              <td>{props.trade_number}</td>
              <td>{props.avg_hold_per}</td>
              {/* <td>{props.max_mdd}</td> */}
              <td>{props.tas}</td>
            </tr>
          </tbody>
        </table>
      </Card>
    </Link>
  );
};

export default InstrumentItem;
